import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const PROFILE_STORE_NAME = 'profile'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
